// ---------------------------------------------------------------------------
// LMS copy content store (paywall + library microcopy).
// Default copy lives here; the backend override (GET /api/lms/copy) is
// deep-merged on top at runtime so text can be edited from the admin panel
// ("Copy LMS" tab) without a redeploy — same pattern as levelTestContent.js.
//
// Placeholders resolved by the consuming components:
//   {N}     → dynamic published-card count
//   {piano} → selected plan label
//   {email} → the lead's email
// Registro: prima persona (è il Prof. che parla), Vocal Fitness®.
// ---------------------------------------------------------------------------

export const LMS_CONTENT = {
  it: {
    paywall: {
      badge: 'Contenuto Premium',
      title: "Sblocca l'intera libreria fonetica di Steve Dapper",
      subtitle:
        'La card /ʊ/ FOOT è aperta, sempre. Le altre {N} contengono lo studio articolatorio completo di ogni suono inglese — britannico e americano.',
      benefits: [
        {
          title: '{N} schede complete',
          desc: 'Ogni vocale, dittongo e consonante: sezione sagittale, punti di articolazione, esempi audio.',
        },
        {
          title: 'La mia voce, non una sintesi',
          desc: 'Ogni parola e ogni frase registrate da me, in britannico e americano.',
        },
        {
          title: 'Laboratorio Pink Trombone',
          desc: 'Un sintetizzatore del tratto vocale dentro ogni scheda: muovi la lingua e senti cosa cambia.',
        },
        {
          title: 'Il catalogo cresce',
          desc: 'Nuove schede e nuove animazioni anatomiche ogni mese.',
        },
      ],
      ctaTemplate: 'Sblocca con il piano {piano}',
      gateHint: "Inserisci una email valida e accetta l'informativa per attivare il pagamento.",
      consent:
        "Acconsento al trattamento dei miei dati personali secondo l'Informativa sulla Privacy.",
      loginLink: 'Hai già un account? Accedi →',
      success: {
        header: 'Pagamento ricevuto. Benvenuto.',
        body:
          'Ho ricevuto il tuo abbonamento {piano}.\nAttivo il tuo accesso a mano — di solito entro poche ore — e ti scrivo a {email} appena è pronto.\nSe hai fretta o qualcosa non torna: admissions@vocalfitness.org',
      },
      cancel:
        'Nessun problema, non ho addebitato nulla. Ho salvato il tuo contatto: quando vuoi riprendere, ripartiamo da qui.',
      error:
        'Il pagamento non è andato a buon fine e non ho addebitato nulla. Il tuo contatto è salvato. Riprova quando vuoi, oppure scrivimi a admissions@vocalfitness.org e lo sistemiamo insieme.',
      disabledHeader: 'Iscrizioni momentaneamente chiuse',
      disabledBody:
        'Scrivimi a admissions@vocalfitness.org e ti avviso appena riaprono.',
    },
  },
};

// ---- Deep-merge backend override over defaults (arrays/scalars replaced) ----
const isObj = (v) => v && typeof v === 'object' && !Array.isArray(v);
export const deepMerge = (base, override) => {
  if (!isObj(base) || !isObj(override)) return override === undefined ? base : override;
  const out = { ...base };
  for (const k of Object.keys(override)) {
    out[k] = isObj(base[k]) && isObj(override[k]) ? deepMerge(base[k], override[k]) : override[k];
  }
  return out;
};

export const getLmsContent = (lang = 'it') => LMS_CONTENT[lang] || LMS_CONTENT.it;

export const mergeLmsContent = (override, lang = 'it') =>
  deepMerge(getLmsContent(lang), override || {});
